import { createFileRoute } from '@tanstack/react-router';
import { DocumentReader } from '@uturn/portal/modules/document-reader';

export const Route = createFileRoute('/_protected/document-reader/')({
	component: DocumentReader,
});
